import Swiper from 'swiper';
import { Thumbs } from 'swiper/modules';
import 'swiper/css';

// Ensure the DOM is fully loaded before initializing Swiper
document.addEventListener('DOMContentLoaded', () => {

  const totalNavSlides = document.querySelectorAll('.swiper-timeline__nav .swiper-slide').length;
  const swiperNav = new Swiper('.swiper-timeline__nav', {
    spaceBetween: 0,
    slidesPerView: 7,
    freeMode: true,
    watchSlidesProgress: true,
    initialSlide: totalNavSlides - 1, // Set the initial slide to the last item
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 5,
      },
      720: {
        slidesPerView: 7,
      }
    }
  });

  const totalContentSlides = document.querySelectorAll('.swiper-timeline__content .swiper-slide').length;
  const initialContentSlideIndex = totalContentSlides - 5;
  const swiperContent = new Swiper('.swiper-timeline__content', {
    modules: [Thumbs],
    initialSlide: initialContentSlideIndex,
    thumbs: {
      swiper: swiperNav,
    },
    autoHeight: true,
    on: {
      slideChange: function () {
        // Update swiperNav to make sure the corresponding navigation item is visible
        const currentIndex = this.activeIndex;
        swiperNav.slideTo(currentIndex);
      },
    },
  });
});
